var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { h, } from "preact";
import { warnOrError } from "./WidgetConfiguration";
export function withWidgetConfiguration(WrappedComponent) {
    var wrappedDisplayName = WrappedComponent.displayName || "Component";
    var wrappingComponent = function (props, context) {
        if (context.widgetConfiguration === undefined) {
            warnOrError(undefined, "<" + wrappedDisplayName + "/> requires a <WidgetConfigurationProvider/>");
        }
        var WrappedAsAny = WrappedComponent;
        var widgetConfiguration = context.widgetConfiguration;
        return (h(WrappedAsAny, __assign({ widgetConfiguration: widgetConfiguration }, props)));
    };
    wrappingComponent.displayName = "withWidgetConfiguration(" + wrappedDisplayName + ")";
    return wrappingComponent;
}
//# sourceMappingURL=withWidgetConfiguration.js.map